import { useI18n } from 'vue-i18n';

export const STATUS_CLASSES = {
  pending: 'bg-n-amber-3 text-n-amber-11 border-n-amber-5',
  confirmed: 'bg-n-teal-3 text-n-teal-11 border-n-teal-5',
  rejected: 'bg-n-ruby-3 text-n-ruby-11 border-n-ruby-5',
};

export const SIGNAL_CLASSES = {
  low_csat: 'bg-n-ruby-3 text-n-ruby-11 border-n-ruby-5',
  reopen: 'bg-n-amber-3 text-n-amber-11 border-n-amber-5',
  slack_alerted: 'bg-n-iris-3 text-n-iris-11 border-n-iris-5',
  label: 'bg-n-teal-3 text-n-teal-11 border-n-teal-5',
  contact_reason: 'bg-n-slate-3 text-n-slate-11 border-n-slate-5',
};

export function useUnhappyCaseConstants() {
  const { t } = useI18n();

  const STATUS_LABELS = {
    pending: t('UNHAPPY_CASES.LIST.FILTERS.PENDING'),
    confirmed: t('UNHAPPY_CASES.LIST.FILTERS.CONFIRMED'),
    rejected: t('UNHAPPY_CASES.LIST.FILTERS.REJECTED'),
  };

  const SIGNAL_LABELS = {
    low_csat: t('UNHAPPY_CASES.DETAIL.SIGNALS.low_csat'),
    reopen: t('UNHAPPY_CASES.DETAIL.SIGNALS.reopen'),
    slack_alerted: t('UNHAPPY_CASES.DETAIL.SIGNALS.slack_alerted'),
    label: t('UNHAPPY_CASES.DETAIL.SIGNALS.label'),
    contact_reason: t('UNHAPPY_CASES.DETAIL.SIGNALS.contact_reason'),
  };

  return { STATUS_LABELS, SIGNAL_LABELS };
}
